import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import { AvContentContainerComponent } from '../../../../Shared/Components/av-content-container/av-content-container.component';
import { AvEmptyStateComponent } from '../../../../Shared/Components/av-empty-state/av-empty-state.component';
import { DEMAND_REFERENCE_ROUTE_PATH } from '../../../Consts/demand-reference-route.const';

@Component({
  selector: 'app-demand-reference-miss',
  standalone: true,
  imports: [COMMON_IMPORTS, AvContentContainerComponent, AvEmptyStateComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './demand-reference-miss.component.html',
  styleUrl: './demand-reference-miss.component.scss',
})
export class DemandReferenceMissComponent {
  private readonly _fb = inject(FormBuilder);
  private readonly _router = inject(Router);

  readonly lookupForm = this._fb.nonNullable.group({
    reference: ['', [Validators.required, Validators.pattern(/\S/)]],
  });

  onSubmitLookup(): void {
    if (this.lookupForm.invalid) {
      this.lookupForm.markAllAsTouched();
      return;
    }

    const reference = this.lookupForm.controls.reference.value.trim();
    // the resolver replaces this entry, so pushing would leave one dead /not-found per failed lookup
    void this._router.navigate([DEMAND_REFERENCE_ROUTE_PATH, reference], { replaceUrl: true });
  }
}
